import React from 'react'
import PropTypes from 'prop-types'
import { Box, HStack, MenuButton } from '@chakra-ui/react'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomLink from '../../CustomLink/CustomLink'
import useHover from '../../../utils/hooks/useHover'

export default function CustomMenuButton({ parentLink, openMenu, onClick }) {
  const navigate = useNavigate()
  const loc = useLocation()

  const { hover, onBlur, onHover } = useHover()
  const onNavigate = (path) => {
    onClick?.()
    if (loc.pathname === path) {
      location.reload()
    } else {
      navigate(path)
    }
  }

  const mouseEnter = () => {
    openMenu()
    onHover()
  }
  return (
    <MenuButton
      zIndex={100}
      onMouseEnter={mouseEnter}
      onMouseLeave={onBlur}
      _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
      onClick={() => onNavigate(parentLink.to)}
      to={parentLink.to}
    >
      <HStack>
        <CustomLink disableUnderLine to={parentLink.to}>
          {parentLink.label}
        </CustomLink>
        <Box>
          <FontAwesomeIcon
            color="white"
            icon={hover ? faAngleUp : faAngleDown}
          />
        </Box>
      </HStack>
    </MenuButton>
  )
}

CustomMenuButton.propTypes = {
  onClick: PropTypes.func,
  openMenu: PropTypes.func,
  parentLink: PropTypes.shape({
    label: PropTypes.string,
    to: PropTypes.string,
  }),
}
